export { DiscoveryLayout } from './DiscoveryLayout';
export { DiscoveryPageLayout, PageBackLink } from './DiscoveryPageLayout';
export type { DiscoveryPageLayoutProps } from './DiscoveryPageLayout';
